import { PAGE_URLS } from "../constants/page-urls"
import Home from "../pages/Home"
import Map from "../pages/Map"
import MatchGame from "../pages/MatchGame"
import Profile from "../pages/Profile"
import Saved from "../pages/Saved"
import Search from "../pages/Search"

/**
 * Här definierar vi vilka sidor som ska visas i appen och vilka props de ska få.
 * Ordningen här bestämmer ordningen i appen
 */
export const routes = [
    {
        path: PAGE_URLS.HOME, // URL:en som ska matchas
        element: Home, // Komponenten som ska visas
        label: "Home", // Går att använda vid typ hjälptext/labels, etc...
        getProps: () => ({}), // Vi kan specificera vilka props som ska skickas till sidan
    },
    {
        path: PAGE_URLS.SEARCH,
        element: Search,
        label: "Search",
        getProps: (props) => ({
            data: props.data,
        }),
    },
    {
        path: PAGE_URLS.SAVED,
        element: Saved,
        label: "Saved",
        getProps: (props) => ({
            data: props.data,
        }),
    },
    {
        path: PAGE_URLS.PROFILE,
        element: Profile,
        label: "Profile",
        getProps: () => ({}),
    },
    {
        path: PAGE_URLS.MAP,
        element: Map,
        label: "Map",
        getProps: (props) => ({
            data: props.data,
        }),
    },
    {
        path: PAGE_URLS.MATCH_GAME,
        element: MatchGame,
        label: "MatchGame",
        getProps: () => ({}),
    },
]
